import { LazyRoutesArr } from '@components/LazyRoutes';
import { useFlagMe358080UseLazyRoutesWrapper } from '@generated/flags/ME-358080-use-lazy-routes-wrapper';
import { DependencyList, useMemo } from 'react';

/** A helper for the `routes` prop on LazyRoutes component. WARNING - if you are using this prop you should be aware that when your dependencies change, there is the possibility that any route defined will be remounted (reloaded) for the user. As a general strategy you should not create routes dynamically. You should define the routes and use feature flags inside of the routes themselves to control the behavior. In doing this, you avoid the above scenario. */
export const useLazyRoutes = (
  cb: () => LazyRoutesArr,
  deps: DependencyList,
): LazyRoutesArr => {
  const shouldUseMemo = useFlagMe358080UseLazyRoutesWrapper();
  const memoRoutes = useMemo(cb, deps);
  return shouldUseMemo ? memoRoutes : cb();
};
